<xt-ui-kit-button
  #button
  [text]="text"
  [iconPosition]="iconPosition"
  [icon]="getIcon()"
  [textAlign]="textAlign"
  [color]="color"
  [buttonStyle]="style"
  [size]="getSize()"
  [width]="width"
  [loading]="loading"
  [isDropdown]="isDropdown"
  [dataCy]="dataCy"
  [isActive]="isActive"
  [ariaLabel]="ariaLabel"
  [disabled]="disabled"
  [disableRipple]="disableRipple"
  (clickEvent)="onClickHandler()"
>
</xt-ui-kit-button>
